









  import { Vue, Component, Prop } from 'vue-property-decorator'

  @Component({
    name: 'OneProductStocksLabel',
  })
  export default class OneProductStocksLabel extends Vue {
    @Prop({
      type: Boolean,
      default: false,
    })
    stockVisibilityModeHidden!: boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    available!: boolean

    @Prop({
      type: String,
      default: '',
    })
    unit!: string

    @Prop({
      type: String,
      default: '',
    })
    labelClass!: string

    @Prop({
      type: String,
      default: 'd-flex justify-content-center align-items-center',
    })
    wrapperClass!: string

    @Prop({
      type: Number,
      required: true,
    })
    quantity!: number

    stockVisibilityModeLabel(available: boolean = false): string {
      return available ? this.$t('stock_visibility_mode.available') as string : this.$t('stock_visibility_mode.unavailable') as string
    }

    get availableLabel() {
      return this.stockVisibilityModeLabel(this.available)
    }

    get quantityValue() {
      if (this.stockVisibilityModeHidden) {
        return this.available ? 1 : 0
      }
      return this.quantity
    }
  }
